import { CustomTabPanel } from "@/erp/sale";
import { a11yProps, EstadosAgendamientoEnumChoice, EstadosPreagendamientoEnumChoice, sizeTab } from "@/shared";
import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { SingleTableBoxScene } from "@/shared/components/ui";
import TablePreAgendamientoSoportePymes from "@/erp/soporte_pymes/preagendamiento_sp/shared/componente/table_agendamiento_pymes/TablePreAgendamientoSoportePymes";
import TablePreAgendamientoPymes from "@/erp/venta_pymes/preagendamiento/shared/componente/table_preagendamiento_pymes/TablePreAgendamientoPymes";

export default function AgendamientoPymesPage() {
  const [valueTab, setValueTab] = useState(0);

  return (
    <>
      <SingleTableBoxScene
        title="Agendamiento PYMES"
      >
        <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
          <Tabs
            value={valueTab}
            onChange={(_event: React.SyntheticEvent, newValue: number) => {
              setValueTab(newValue);
            }}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="scrollable force tabs preventa"
          >
            <Tab label={'Agendado'} {...a11yProps(0)} />
            <Tab label={'Recordinado'} {...a11yProps(1)} />
            <Tab label={'Gestion Venta'} {...a11yProps(2)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={valueTab} index={0}>
          <TablePreAgendamientoPymes
            estado_preagendamiento={EstadosPreagendamientoEnumChoice.FINALIZADO}
          />
          {/* <TableAgendamientoPymes
            stateAgendamiento={EstadosAgendamientoEnumChoice.FINALIZADO}
          /> */}
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={1}>
          <TablePreAgendamientoPymes
            estado_preagendamiento={EstadosPreagendamientoEnumChoice.RECORDINADO}
          />
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={2}>
          <TablePreAgendamientoSoportePymes
            estado_aceptacion={true}
            estado_preagendamiento={EstadosAgendamientoEnumChoice.PRERECHAZADO}
          />
        </CustomTabPanel>
      </SingleTableBoxScene>

    </>
  )

}